// extracted by mini-css-extract-plugin
export default {"wrapper":"CreatePersonForm-module__wrapper___IyYVx","toggleDetails":"CreatePersonForm-module__toggleDetails___B2zOp","details":"CreatePersonForm-module__details___EY3PG"};